import React from 'react';
import { Typography } from '@mui/material';
import { CenteredFlexBox, ColumnFlexBox } from '../../../FlexBox';

/**
 * DetailList — caption/value rows for the redemption tap-to-show-details cards
 * (mirrors the desktop tooltip content). `items: [{ caption, value }]`.
 */
const DetailList = function DetailList({ items = [] }) {
  return (
    <ColumnFlexBox sx={{ gap: 0.85 }}>
      {items.map(({ caption, value }) => (
        <CenteredFlexBox key={caption} sx={{ justifyContent: 'space-between' }}>
          <Typography sx={{ fontSize: 13, color: '#64748B' }}>
            {caption}
          </Typography>
          <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
            {value}
          </Typography>
        </CenteredFlexBox>
      ))}
    </ColumnFlexBox>
  );
};

export default DetailList;
